import { isPrimitive, stableStringify } from 'utils/common';

import { useMemo } from 'react';

function stabilizeDependencies(deps: ReadonlyArray<unknown>) {
  return deps.map((dep) => (isPrimitive(dep) ? dep : stableStringify(dep)));
}

export function useValueMemo<T>(
  callback: () => T,
  deps: ReadonlyArray<unknown>
): T {
  return useMemo(callback, stabilizeDependencies(deps));
}
